import { render, staticRenderFns } from "./GoodComponent.vue?vue&type=template&id=038fd816&scoped=true"
import script from "./GoodComponent.vue?vue&type=script&lang=js"
export * from "./GoodComponent.vue?vue&type=script&lang=js"
import style0 from "./GoodComponent.vue?vue&type=style&index=0&id=038fd816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038fd816",
  null
  
)

export default component.exports